import { useChooseRef } from '@agilepoint/wat-react-ux';
import { useCallback, useEffect } from 'react';

export function useKeyboardAccessibility<T extends HTMLElement>(args: { elementRef?: React.RefObject<T>, stopPropagation?: boolean, callback: any }) {
    const { callback, elementRef: optionalRef } = args;
    const elementRef = useChooseRef<T>(optionalRef);

    const onKeyDown = useCallback((ev: KeyboardEvent) => {
        if (ev.code === 'Enter') {
            if (args?.stopPropagation) {
                ev.stopPropagation();
            }
            callback();
        }
    }, [args, callback]);

    useEffect(() => {
        const current = elementRef.current;
        if (current) {
            current.addEventListener('keydown', onKeyDown);
        }

        return () => {
            current?.removeEventListener('keydown', onKeyDown);
        };
    }, [callback, elementRef, onKeyDown]);

    return { elementRef };
}
